import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomModal from "src/components/configuracion/components/customModal";
import {
  getCobranzaEmailHistoryBody,
  getCobranzaEmailHistorySummary,
} from "./cobranzaGestionUtils";

export default function CobranzaEmailHistoryPreviewButton({ entry }) {
  const { t } = useTranslation("cobranza");
  const [open, setOpen] = useState(false);
  const bodyHtml = useMemo(() => getCobranzaEmailHistoryBody(entry), [entry]);
  const subject = useMemo(() => getCobranzaEmailHistorySummary(entry, t), [entry, t]);

  if (!bodyHtml) return null;

  return (
    <>
      <button
        type="button"
        className="cf-gestion-email-history__preview-btn"
        onClick={() => setOpen(true)}
      >
        Ver mensaje
      </button>
      <CustomModal
        open={open}
        onClose={() => setOpen(false)}
        title={subject}
        classNameModal="cf-gestion-email-preview-modal"
        classNameContent="cf-gestion-email-preview-modal__content"
        content={
          <div className="cf-gestion-email-preview-modal__frame-wrap">
            <iframe
              title={subject}
              className="cf-gestion-email-preview-modal__frame"
              srcDoc={bodyHtml}
            />
          </div>
        }
        hideActions
        modalStyle={{ maxWidth: "96%", width: "1100px", maxHeight: "92vh" }}
      />
    </>
  );
}
